// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + ({"188":"configs","930":"setup","945":"dashboard","980":"setup-azure"}[chunkId] || chunkId) + "." + {"188":"63374b88","249":"3b4251c1","930":"049cba60","945":"458cf2a4","980":"fe3f9b1f","989":"03e8d111"}[chunkId] + ".chunk.js";
};